import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PHBHPLayoutPackageService, PHBHPListApiService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { filter } from 'rxjs/operators';
import { AppConfig } from 'src/app/app.config';

@Component({
  selector: 'hygiene-check-menu',
  templateUrl: './hygiene-check-menu.component.html',
  styleUrls: ['./hygiene-check-menu.component.css']
})
export class HygieneCheckMenuComponent implements OnInit {

  constructor(public appConfig: AppConfig,
      public layoutService: PHBHPLayoutPackageService,
      private service: PHBHPListApiService,
      private modalService: BsModalService,
      private router: Router) {
        
       }

  ngOnInit(): void {
  }

}
